import graphql from "babel-plugin-relay/macro";

export default graphql`
  query getSettingsQuery($orgId: ID!, $propertyId: ID) {
    hyeventsSetting(orgId: $orgId, propertyId: $propertyId) {
      approvalRequired
      approverEmails
      agentApprovalEmails
      hyeventsBccEmails
    }
  }
`;